/**
 * Housing Tier System Data Model
 *
 * Housing represents the player's "future self" goal - the ultimate lifestyle upgrade.
 * Players progress through 7 tiers from Studio to Beachfront Estate.
 */

/**
 * @typedef {Object} HousingTier
 * @property {number} id - Tier level (0-6)
 * @property {string} name - Display name
 * @property {number} cost - M cost to purchase
 * @property {string} description - Flavor text for the tier
 */

export const HOUSING_TIERS = [
  {
    id: 0,
    name: 'Studio',
    cost: 0,
    description: 'A cozy start to your journey'
  },
  {
    id: 1,
    name: '1BR Apartment',
    cost: 500,
    description: 'Room to breathe and grow'
  },
  {
    id: 2,
    name: '2BR Apartment',
    cost: 2000,
    description: 'Space for life and dreams'
  },
  {
    id: 3,
    name: 'Small House',
    cost: 8000,
    description: 'A place to call your own'
  },
  {
    id: 4,
    name: 'Modern House',
    cost: 25000,
    description: 'Living in style and comfort'
  },
  {
    id: 5,
    name: 'Penthouse',
    cost: 75000,
    description: 'Above the city, above the rest'
  },
  {
    id: 6,
    name: 'Beachfront Estate',
    cost: 200000,
    description: 'The ultimate retirement paradise'
  }
];

/**
 * Get the current housing tier by level
 * @param {number} level - Housing level (0-6)
 * @returns {HousingTier|null} The tier object or null if invalid level
 */
export const getCurrentTier = (level) => {
  return HOUSING_TIERS.find(tier => tier.id === level) || null;
};

/**
 * Get the next housing tier (for upgrade display)
 * @param {number} level - Current housing level (0-6)
 * @returns {HousingTier|null} The next tier object or null if at max level
 */
export const getNextTier = (level) => {
  if (level >= HOUSING_TIERS.length - 1) {
    return null; // Already at max tier
  }
  return HOUSING_TIERS[level + 1] || null;
};
